export enum RoleType {
  Admin,
  Provider,
  Consumer,
  OccurrencesAdmin,
  OccurrencesSupervisor,
}

export enum SiiaPermissionType {
  CreateOccurrence,
  PublishOccurrence,
  CancelOccurrence,
  AcceptOccurrence,
  ResolveOccurrence,
}
